import createVueComponent from '../createVueComponent';

const BluetoothOff = createVueComponent('BluetoothOffIcon', [
  ['path', { d: 'm17 17-5 5V12l-5 5', key: 'v5aci6' }],
  ['path', { d: 'm2 2 20 20', key: '1ooewy' }],
  ['path', { d: 'M14.5 9.5 17 7l-5-5v4.5', key: '1kddfz' }],
]);

export default BluetoothOff;
